// extracted by mini-css-extract-plugin
export var paginationContainer = "_88-0";